import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import HiringHubHeader from "../shared/general/HiringHubHeader";
import ActionBar from "../shared/general/ActionBar";
import NotFoundError from "../shared/error/NotFoundError";
import Theme from "../../theme/theme";
import { Wrapper, Container, Page } from "./styles/forwardable-cv-styles";
import DisplayPdf from "../shared/general/DisplayPdf";

export interface IForwardableCvProps {
  cv: string;
  candidateName: string;
  jobTitle: string;
}

export const ForwardableCv: FunctionComponent<IForwardableCvProps> = ({
  cv,
  candidateName,
  jobTitle,
}) => {
  const actionBarTitle =
    !candidateName || !jobTitle
      ? `Not found`
      : `${candidateName} - ${jobTitle}`;
  return (
    <Page>
      <Theme>
        <HiringHubHeader color="purple" />
        <ActionBar
          title={actionBarTitle}
          mobileTitle={actionBarTitle}
          noMargin
          fullWidth
          topOffset={90}
        />
        <Wrapper>
          <Container>
            {cv ? <DisplayPdf data={cv} /> : <NotFoundError />}
          </Container>
        </Wrapper>
      </Theme>
    </Page>
  );
};

ForwardableCv.propTypes = {
  cv: PropTypes.string.isRequired,
  candidateName: PropTypes.string.isRequired,
  jobTitle: PropTypes.string.isRequired,
};

export default ForwardableCv;
